<template>
  <div
    ref="show-card-list"
    :data-segment-uuid="shows.uuid"
    class="show-card-list"
    data-test="show-card-list">
    <div class="container">
      <div class="draggable-element">
        <picture-component
          :src="shows.display_image_url"
          dimensions="h=86&w=86" />
        <p class="small-text">{{ shows.title | truncate(30) }}</p>
      </div>
      <div :class="`main-content ${noBorder ? 'without-border' : ''}`">
        <div class="tags">
          <!--  -->
          <FreeEpisodeIndicator v-if="isFree && !isPremiumMember" />
          <!-- <PremiumIndicator v-if="showPremiumIndicator" /> -->
          <!--  -->
        </div>
        <el-row
          type="flex"
          justify="space-between"
          class="d-flex-wrap">
          <div class="show-play-button">
            <el-progress
              v-show="playerIcon === playIcon || playerIcon === pauseIcon || isLoading"
              :percentage="Number(currentProgress)"
              :stroke-width="2"
              :width="42"
              :show-text="false"
              type="circle"
              color="#00AECB"
              @click.native="playerIcon === playIcon ? playEpisode() : playerIcon === pauseIcon ? pauseEpisode(): ''"/>
            <svg v-if="playerIcon === playIcon" data-test="btn-playepisode" class="play-button" svg-inline="" @click="playEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 121 156"><defs><path id="ic_play_blue_svg__a" d="M496.406096,345.69723 C491.541695,349.359203 485.132833,350.027479 479.65336,347.444103 C474.173887,344.860725 470.480935,339.429801 470,333.247692 L470,208.752308 C470.480935,202.570199 474.173887,197.139275 479.65336,194.555898 C485.132833,191.972521 491.541695,192.640797 496.406096,196.30277 L584.381047,258.550462 C588.505275,261.268282 591,265.960591 591,271 C591,276.039409 588.505275,280.731718 584.381047,283.449538 L496.406096,345.69723 Z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-470.000000, -193.000000)"><use fill="#00AECB" xlink:href="#ic_play_blue_svg__a"/></g></g></svg>
            <svg v-if="playerIcon === pauseIcon" data-test="btn-pauseepisode" class="pause-button" svg-inline="" @click="pauseEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24"><g fill="none" fill-rule="evenodd"><g fill="#00AECB" fill-rule="nonzero"><g><path d="M1.666667,0 L6.333334,0 C6.885618,0 7.333334,0.447715 7.333334,1 L7.333334,23 C7.333334,23.552285 6.885618,24 6.333334,24 L1.666667,24 C1.114382,24 0.666667,23.552285 0.666667,23 L0.666667,1 C0.666667,0.447715 1.114382,0 1.666667,0 Z" transform="translate(-153.000000, -320.000000) translate(153.000000, 320.000000)"/><path d="M13.666667,0 L18.333334,0 C18.885618,0 19.333334,0.447715 19.333334,1 L19.333334,23 C19.333334,23.552285 18.885618,24 18.333334,24 L13.666667,24 C13.114382,24 12.666667,23.552285 12.666667,23 L12.666667,1 C12.666667,0.447715 13.114382,0 13.666667,0 Z" transform="translate(-153.000000, -320.000000) translate(153.000000, 320.000000)"/></g></g></g></svg>
            <svg v-if="playerIcon === replayIcon" class="replay-button" svg-inline="" @click="replayEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 44"><defs><path id="ic_replay_blue_svg__a" d="M17.2802001,31.1473435 C16.7584662,31.5390313 16.0710801,31.6105108 15.4833763,31.3341905 C14.8956726,31.0578702 14.4995829,30.4769738 14.448,29.8157299 L14.448,16.4995939 C14.4995829,15.83835 14.8956726,15.2574536 15.4833763,14.9811333 C16.0710801,14.704813 16.7584662,14.7762925 17.2802001,15.1679803 L26.7160009,21.8260483 C27.1583473,22.1167487 27.4259203,22.6186422 27.4259203,23.1576619 C27.4259203,23.6966816 27.1583473,24.1985751 26.7160009,24.4892755 L17.2802001,31.1473435 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g transform="translate(-595.000000, -200.000000) translate(595.406000, 200.043583)"><path fill="#AFE7F1" d="M19.5613044,43.344 C30.3474247,43.344 39.1225044,34.6205 39.1225044,23.8979621 C39.1225044,18.9986762 37.2823071,14.3166378 33.940987,10.7144563 C30.6028016,7.11589025 26.0708025,4.91502381 21.1798755,4.51742804 L19.8815704,4.41183494 L19.8815704,-3.55271368e-15 L10.9786979,5.31527801 L19.8815704,10.630556 L19.8815704,6.11387235 L21.4359839,6.27593064 C25.7880489,6.72977892 29.8073089,8.76646032 32.7532337,12.0107099 C35.7176535,15.27527 37.3502265,19.4968672 37.3502265,23.8979621 C37.3502265,33.6683544 29.3701171,41.617186 19.5613044,41.617186 C9.7524918,41.617186 1.77238239,33.6683544 1.77238239,23.8979621 C1.77238239,19.3387434 3.50683442,15.0075123 6.65620391,11.702225 C6.81461281,11.5359132 6.89862386,11.3195164 6.89266785,11.0929113 C6.88671185,10.8654555 6.79099776,10.6529932 6.62318464,10.4946567 C6.45004247,10.3313224 6.22810283,10.2502933 6.00668564,10.2502933 C5.76949026,10.2502933 5.53302632,10.3432322 5.35748084,10.527515 C1.90268311,14.1534098 -1.42108547e-14,18.9018028 -1.42108547e-14,23.8979621 C-1.42108547e-14,34.6205 8.77518414,43.344 19.5613044,43.344"/><use fill="#00AECB" xlink:href="#ic_replay_blue_svg__a"/></g></g></g></svg>
            <i
              v-if="isLoading"
              class="el-icon-loading text-blue"/>
          </div>
          <div class="show-content">
            <div class="tags">
              <FreeEpisodeIndicator v-if="isFree && !isPremiumMember" />
              <!-- <PremiumIndicator v-if="showPremiumIndicator" /> -->
            </div>
            <div>
              <div>
                <router-link
                  :class="{ 'text-gray': currentProgress >= playback }"
                  :to="constructEDPUrl"
                  data-test="title-episode"
                  @click.native="triggerContentSelectEvent">{{ shows.title }}
                </router-link>
              </div>
              <div class="show-image-responsive">
                <picture-component
                  :src="shows.display_image_url"
                  dimensions="h=86&w=86"
                />
              </div>
            </div>
            <p
              v-if="shows.description"
              :class="[{'text-gray': currentProgress>=playback || episode_was_played},'description']"
              data-test="show-content-description"
              @click="goToEDP"
            >
              {{ shows.description }}
            </p>
            <div class="meta-and-action">
              <div class="meta">
                <div
                  v-if="season_no && episode_no"
                  class="show-season">
                  <p v-if="season_no && episode_no">{{ "S"+(season_no || 0) }} {{ "E"+(episode_no || 0) }}</p>
                </div>
                <div v-if="season_no && episode_no">|</div>
                <div class="show-date">
                  <p v-show="shows.released_at">{{ shows.released_at | dateFormat }}</p>
                  <p v-show="shows.release_date && !shows.released_at">{{ shows.release_date | dateFormat }}</p>
                </div>
                <div v-if="shows.released_at || shows.release_date">|</div>
                <div class="show-duration">
                  <p v-if="currentProgress >= playback">
                    <img
                      width="12"
                      src="../assets/images/played_icon.svg"
                      alt="Play Icon"> Played
                  </p>
                  <p v-if="!episodeListened"> {{ episodeRunTime }}</p>
                </div>
              </div>
              <div
                v-if="canAddToLibraryBtn"
                class="add-remove-btn">
                <span
                  v-show="deleting_episode || adding_episode"
                  class="processing">
                  <i class="el-icon-loading" />
                  {{ deleting_episode ? 'Deleting...' : adding_episode ? 'Adding...' : '' }}</span>
                <img
                  v-button-event="{buttonText: 'Add Episode', buttonLink: null}"
                  v-if="!deleting_episode && !adding_episode"
                  :src="addEpisode ? addLibraryIcon : removeEpisode ? inLibraryIcon : ''"
                  width="24"
                  @click="addEpisode ? addEpisodeToLibrary(shows.uuid) : removeEpisode ? deleteEpisode(shows.uuid) : ''">
                <span
                  v-if="!deleting_episode || !adding_episode"
                  data-test="btnaddtomyShows"
                  @click="addEpisode ? addEpisodeToLibrary(shows.uuid) : removeEpisode ? deleteEpisode(shows.uuid) : ''">
                  {{ addEpisode ? 'Add to Bookmarks' : removeEpisode ? 'Added' : '' }}</span>
              </div>
            </div>
          </div>
          <div :class="[{'is-draggable': draggableIcon},'show-image']">
            <picture-component
              :src="shows.display_image_url"
              dimensions="h=86&w=86" />
            <PremiumIndicator v-if="showPremiumIndicator" />
          </div>
          <div
            v-if="draggableIcon"
            class="drag-button"
            data-test="drag-button">
            <img
              width="24"
              src="../assets/images/ic_drag.svg"
              alt="Drag Button">
          </div>
        </el-row>
        <div class="responsive-meta-and-actions">
          <div
            class="responsive-details"
            data-test="description-episode">
            <span v-if="season_no && episode_no">{{ "S"+(season_no || 0) }} {{ "E"+(episode_no || 0) }}</span> |
            <span v-if="shows.released_at">{{ shows.released_at | dateFormat }}</span> |
            <span v-if="shows.release_date && !shows.released_at">{{ shows.release_date | dateFormat }}</span>
            <span v-if="currentProgress >= playback">
              <img
                width="11"
                src="../assets/images/played_icon.svg"
                alt="Play Icon"> Played
            </span>
            <span v-if="!episodeListened"> {{ episodeRunTime }}</span>
          </div>
          <div class="responsive-buttons">
            <div class="show-play-button">
              <el-progress
                v-show="playerIcon === playIcon || playerIcon === pauseIcon || isLoading"
                :percentage="Number(currentProgress)"
                :stroke-width="2"
                :width="42"
                :show-text="false"
                type="circle"
                color="#00AECB"
                @click.native="playerIcon === playIcon ? playEpisode() : playerIcon === pauseIcon ? pauseEpisode(): ''"/>
              <svg v-if="playerIcon === playIcon" class="play-button" svg-inline="" data-test="show-play-button-icon" @click="playEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 121 156"><defs><path id="ic_play_blue_svg__a" d="M496.406096,345.69723 C491.541695,349.359203 485.132833,350.027479 479.65336,347.444103 C474.173887,344.860725 470.480935,339.429801 470,333.247692 L470,208.752308 C470.480935,202.570199 474.173887,197.139275 479.65336,194.555898 C485.132833,191.972521 491.541695,192.640797 496.406096,196.30277 L584.381047,258.550462 C588.505275,261.268282 591,265.960591 591,271 C591,276.039409 588.505275,280.731718 584.381047,283.449538 L496.406096,345.69723 Z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-470.000000, -193.000000)"><use fill="#00AECB" xlink:href="#ic_play_blue_svg__a"/></g></g></svg>
              <svg v-if="playerIcon === pauseIcon" class="pause-button" svg-inline="" data-test="show-pause-button-icon" @click="pauseEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24"><g fill="none" fill-rule="evenodd"><g fill="#00AECB" fill-rule="nonzero"><g><path d="M1.666667,0 L6.333334,0 C6.885618,0 7.333334,0.447715 7.333334,1 L7.333334,23 C7.333334,23.552285 6.885618,24 6.333334,24 L1.666667,24 C1.114382,24 0.666667,23.552285 0.666667,23 L0.666667,1 C0.666667,0.447715 1.114382,0 1.666667,0 Z" transform="translate(-153.000000, -320.000000) translate(153.000000, 320.000000)"/><path d="M13.666667,0 L18.333334,0 C18.885618,0 19.333334,0.447715 19.333334,1 L19.333334,23 C19.333334,23.552285 18.885618,24 18.333334,24 L13.666667,24 C13.114382,24 12.666667,23.552285 12.666667,23 L12.666667,1 C12.666667,0.447715 13.114382,0 13.666667,0 Z" transform="translate(-153.000000, -320.000000) translate(153.000000, 320.000000)"/></g></g></g></svg>
              <svg v-if="playerIcon === replayIcon" class="replay-button" svg-inline="" data-test="show-replay-button-icon" @click="replayEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 44"><defs><path id="ic_replay_blue_svg__a" d="M17.2802001,31.1473435 C16.7584662,31.5390313 16.0710801,31.6105108 15.4833763,31.3341905 C14.8956726,31.0578702 14.4995829,30.4769738 14.448,29.8157299 L14.448,16.4995939 C14.4995829,15.83835 14.8956726,15.2574536 15.4833763,14.9811333 C16.0710801,14.704813 16.7584662,14.7762925 17.2802001,15.1679803 L26.7160009,21.8260483 C27.1583473,22.1167487 27.4259203,22.6186422 27.4259203,23.1576619 C27.4259203,23.6966816 27.1583473,24.1985751 26.7160009,24.4892755 L17.2802001,31.1473435 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g transform="translate(-595.000000, -200.000000) translate(595.406000, 200.043583)"><path fill="#AFE7F1" d="M19.5613044,43.344 C30.3474247,43.344 39.1225044,34.6205 39.1225044,23.8979621 C39.1225044,18.9986762 37.2823071,14.3166378 33.940987,10.7144563 C30.6028016,7.11589025 26.0708025,4.91502381 21.1798755,4.51742804 L19.8815704,4.41183494 L19.8815704,-3.55271368e-15 L10.9786979,5.31527801 L19.8815704,10.630556 L19.8815704,6.11387235 L21.4359839,6.27593064 C25.7880489,6.72977892 29.8073089,8.76646032 32.7532337,12.0107099 C35.7176535,15.27527 37.3502265,19.4968672 37.3502265,23.8979621 C37.3502265,33.6683544 29.3701171,41.617186 19.5613044,41.617186 C9.7524918,41.617186 1.77238239,33.6683544 1.77238239,23.8979621 C1.77238239,19.3387434 3.50683442,15.0075123 6.65620391,11.702225 C6.81461281,11.5359132 6.89862386,11.3195164 6.89266785,11.0929113 C6.88671185,10.8654555 6.79099776,10.6529932 6.62318464,10.4946567 C6.45004247,10.3313224 6.22810283,10.2502933 6.00668564,10.2502933 C5.76949026,10.2502933 5.53302632,10.3432322 5.35748084,10.527515 C1.90268311,14.1534098 -1.42108547e-14,18.9018028 -1.42108547e-14,23.8979621 C-1.42108547e-14,34.6205 8.77518414,43.344 19.5613044,43.344"/><use fill="#00AECB" xlink:href="#ic_replay_blue_svg__a"/></g></g></g></svg>
              <i
                v-if="isLoading"
                class="el-icon-loading text-blue"/>
            </div>
            <div class="btn-left">
              <div
                v-if="canAddToLibraryBtn"
                class="add-remove-btn">
                <span
                  v-show="deleting_episode || adding_episode"
                  class="processing">
                  <i class="el-icon-loading" />
                  {{ deleting_episode ? 'Deleting...' : adding_episode ? 'Adding...' : '' }}</span>
                <div
                  v-button-event="{buttonText: addEpisode ? 'Add Episode' : removeEpisode ? 'Remove Episode' : '', buttonLink: null}"
                  v-if="addEpisode && !removeEpisode"
                  class="svg-btn"
                  @click="addEpisode ? addEpisodeToLibrary(shows.uuid) : removeEpisode ? deleteEpisode(shows.uuid) : ''">
                  <img
                    src="../assets/images/ic_add_episode.svg">
                </div>
                <div
                  v-button-event="{buttonText: addEpisode ? 'Add Episode' : removeEpisode ? 'Remove Episode' : '', buttonLink: null}"
                  v-if="!addEpisode && removeEpisode"
                  class="svg-btn"
                  @click="addEpisode ? addEpisodeToLibrary(shows.uuid) : removeEpisode ? deleteEpisode(shows.uuid) : ''">
                  <img
                    src="../assets/images/bookmarked.svg">
                </div>
                <span
                  v-button-event="{buttonText: addEpisode ? 'Add Episode' : removeEpisode ? 'Remove Episode' : '', buttonLink: null}"
                  v-show="!deleting_episode || !adding_episode"
                  @click="addEpisode ? addEpisodeToLibrary(shows.uuid) : removeEpisode ? deleteEpisode(shows.uuid) : ''">
                  {{ addEpisode ? 'Add to Bookmarks' : removeEpisode ? 'Added' : '' }}
                </span>
              </div>
              <span
                v-if="draggableIcon"
                class="border-vertical"/>
              <div
                v-if="draggableIcon"
                class="drag-button">
                <img
                  width="24"
                  src="../assets/images/ic_drag.svg"
                  alt="Drag Button">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <login-modal
      v-if="show_login_modal"
      :show_modal="show_login_modal"
      @modalClosed="show_login_modal = false"/>
  </div>
</template>
<script>
import * as log from 'loglevel';
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import SegmentEvent from '../services/PlayerEvent';
import Episode from '../services/Episode';
import Podcast from '../services/Podcast';
import replayIcon from '../assets/images/ic_replay_blue.svg';
import addLibraryIcon from '../assets/images/ic_add_episode.svg';
import inLibraryIcon from '../assets/images/bookmarked.svg';
import playIcon from '../assets/images/ic_play_blue.svg';
import pauseIcon from '../assets/images/ic_pause_blue.svg';
import freeEpisode from '../assets/images/tag_teal.svg';

export default {
  name: 'ShowCardsList',
  components: {
    FreeEpisodeIndicator: () => import('./FreeEpisodeIndicator'),
    Loader: () => import('./Loader'),
    LoginModal: () => import('./LoginModal'),
    PremiumIndicator: () => import('./PremiumIndicator'),
  },
  props: {
    shows: {
      type: Object,
      default: () => {},
    },
    draggableIcon: {
      type: Boolean,
      default: false,
    },
    playlistType: {
      type: String,
      default: 'show',
    },
    showTitle: {
      type: String,
      default: '',
    },
    toggleDetail: {
      type: Boolean,
      default: false,
    },
    total_seasons: {
      type: Number,
      default: 0,
    },
    current_season: {
      type: Number,
      default: 0,
    },
    current_episode_index: {
      type: Number,
      default: 0,
    },
    season_no: {
      type: Number,
      default: 0,
    },
    episode_no: {
      type: Number,
      default: 0,
    },
    podcast_meta: {
      type: Object,
      default: () => {},
    },
    podcast: {
      type: Object,
      default: () => {},
    },
    isExclusive: {
      type: Boolean,
      default: false,
    },
    isFree: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: () => false,
    },
    bucket: {
      type: Object,
      default: () => {},
    },
    showPremiumIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      addLibraryIcon,
      inLibraryIcon,
      playIcon,
      freeEpisode,
      pauseIcon,
      replayIcon,
      episode_service: new Episode(),
      show_service: new Podcast(),
      adding_episode: false,
      deleting_episode: false,
      trim_text: true,
      deleting_show: false,
      showDragCard: false,
      playback: 95,
      episode_was_played: false,
      text_limit: 125,
      title_text_limit: 45,
      record_id_episode: this.shows.record_id,
      is_premium: true,
      show_login_modal: false,
      eventProvider: new SegmentEvent(),
      draggableOptions: {
        animation: 500,
        ghostClass: 'ghost',
        chosenClass: 'chosen',
        dragClass: 'drag',
        delay: 50,
        scrollSensitivity: 15,
        scrollSpeed: 50,
        scroll: true,
      },
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
      isLoggedIn: 'loggedIn',
      isItemLoading: 'libraryv2/isItemLoading',
      isEpisodeInLibrary: 'libraryv2/isEpisodeInLibrary',
    }),
    inUserLibrary() {
      return this.isEpisodeInLibrary(this.shows.uuid);
    },
    isPremiumMember() {
      return this.user && this.user.is_subscribed;
    },
    canAddToLibraryBtn() {
      return ((this.isLoggedIn && (!this.isExclusive || this.isFree)) || (this.isPremiumMember && this.isExclusive));
    },
    currentProgress() {
      const progress = this.$store.getters.episodeProgressByUuid(this.shows.uuid);

      if (progress) {
        // this.$emit('episode-progress', { uuid: this.shows.uuid, episode_progress: progress });
        return progress.progress_percent;
      }

      return 0;
    },
    isPlaying() {
      const currentlyPlayingEpisode = this.$store.getters.episode;
      const playing = this.$store.getters.play;

      return playing && (currentlyPlayingEpisode && (currentlyPlayingEpisode.uuid === this.shows.uuid));
    },
    isLoading() {
      const { status, episode } = this.$store.getters;
      return status === 'loading' && episode && (episode.uuid === this.shows.uuid);
    },
    showReplayIcon() {
      return ((this.currentProgress >= this.playback || this.episode_was_played) && !this.isLoading);
    },
    addEpisode() {
      return !this.inUserLibrary && !this.adding_episode;
    },
    removeEpisode() {
      return this.inUserLibrary && !this.deleting_episode;
    },
    episodeRunTime() {
      return this.currentProgress >= this.playback ? 'Played' : this.$options.filters.humanizedTimeFilter(this.shows.runtime || 0);
    },
    episodeListened() {
      if (this.shows) {
        const progress = this.$store.getters.episodeProgressByUuid(this.shows.uuid);

        if (progress) {
          return progress.progress_percent >= 95;
        }

        return false;
      }

      return false;
    },
    playerIcon() {
      if (this.isLoading) {
        return null;
      }

      if (this.isPlaying) {
        return this.pauseIcon;
      }

      if (this.episodeListened && !this.isPlaying) {
        return this.replayIcon;
      }

      return this.playIcon;
    },
    showPremiumIndicator() {
      if (this.shows.is_exclusive || (this.shows.season && this.shows.season.podcast && this.shows.season.podcast.is_exclusive)) {
        if (!this.isFree && !this.isPremiumMember) {
          return true;
        }

        if (this.isPremiumMember) {
          return true;
        }
      }

      return false;
    },
    constructEDPUrl() {
      return `/listen/${_.kebabCase(this.podcast.publisher.name)}/${_.kebabCase(this.podcast.title)}/${_.kebabCase(this.shows.title)}/${this.shows.uuid}`;
    },
  },
  mounted() {
    const ctx = this;
    let isScrolling;
    this.scrollListener = function () {
      window.clearTimeout(isScrolling);
      isScrolling = setTimeout(() => {
        ctx.checkIfVisible();
      }, 66);
    };
    document.body.addEventListener('scroll', this.scrollListener);
    this.checkIfVisible();
  },
  destroyed() {
    document.body.removeEventListener('scroll', this.scrollListener);
  },
  methods: {
    ...mapActions({
      removeEpisodeFromLibraryV2: 'libraryv2/removeEpisodeFromLibrary',
      addEpisodeToLibraryV2: 'libraryv2/addEpisodeToLibrary',
    }),
    checkIfVisible() {
      const viewportHeight = document.body.offsetHeight;
      const element = this.$refs['show-card-list'];
      if (element) {
        const elementRect = element.getBoundingClientRect();
        const elementPos = elementRect.top;
        const threshold = (element.offsetHeight / 3); // part of element within viewport
        const isVisible = elementPos >= (-1 * threshold) && (elementPos + threshold) <= viewportHeight;
        if (isVisible && this.shows.uuid.length > 1) {
          element.classList.add('is-visible');
        }
      }
    },
    playEpisode() {
      this.shows.screen_name = this.bucket.screen_name;
      const trailerAsEpisode = this.shows.episode_type === 'trailer' || this.shows.is_trailer_in_episodes;
      this.$store.dispatch('setTrailerAsEpisode', trailerAsEpisode);
      // If user is not premium and show is exclusive, then show PremiumContentDialog.
      this.$store.dispatch('isAllowedPremiumEpisode', this.shows);
      if (this.showPremiumModal) return;
      // If trailer is listed in episodes list then treat it as an episode
      if (trailerAsEpisode) {
        this.shows.episode_type = 'full';
        this.shows.is_trailer_in_episodes = true;
      }

      this.episode_was_played = false;
      this.$store.dispatch('setPlaylistType', this.playlistType);
      this.shows.show_title = this.showTitle ? this.showTitle : '';

      this.shows.meta = {
        podcast_meta: this.podcast_meta,
        current_episode_index: this.current_episode_index,
        total_seasons: this.total_seasons,
        current_season: this.current_season,
      };

      this.shows.show_title = this.showTitle;
      // Play episode using central store
      const currentEpisode = this.$store.getters.episode;

      if (currentEpisode.uuid === this.shows.uuid && !trailerAsEpisode) {
        this.$store.dispatch('play');
        this.eventProvider.triggerEpisodePlayEvent(this.shows, 'resume_episode');
      } else {
        this.loadMediaInPlayer(this.shows.media_url, this.shows.is_exclusive, this.shows.episode_type, trailerAsEpisode);
        if (currentEpisode && currentEpisode.uuid) {
          this.eventProvider.triggerEpisodePauseEvent(currentEpisode, 'episode_select');
        }
        this.$store.dispatch('setAndPlayEpisode', this.shows);
        this.eventProvider.triggerEpisodePlayEvent(this.shows, 'press_play');
      }
      this.$store.commit('setContinuousListeningActivePodcast', this.shows.season.podcast.uuid);
    },
    pauseEpisode() {
      this.episode_was_played = false;
      // window.eventBus.$emit("pause-podcast",{})
      this.$store.dispatch('pause');
      this.eventProvider.triggerEpisodePauseEvent(this.shows, 'pause');
    },
    replayEpisode() {
      this.$store.dispatch('setProgress', 0);
      this.playEpisode();
    },
    addEpisodeToLibrary(id) {
      // If user is not premium and show is exclusive, then show PremiumContentDialog.
      this.$store.dispatch('isAllowedPremiumEpisode', this.shows);
      if (this.showPremiumModal) return;

      this.adding_episode = true;
      this.addEpisodeToLibraryV2(id).then(() => {
        this.adding_episode = false;
        this.shows.in_library = true;
        // this.showSuccessMsg('Episode Added to Library');
        this.eventProvider.triggerEpisodeAddEvent(this.shows);
      }).catch((err) => {
        this.$emit('added', 0);
        this.adding_episode = false;
        this.showErrorMsg('Failed to add episode to your library!');
        log.error(err.message);
      });
    },
    deleteEpisode(delId) {
      this.deleting_episode = true;
      this.removeEpisodeFromLibraryV2(delId)
        .then(() => {
          this.deleting_episode = false;
          this.$emit('deleted', this.shows.uuid);
          // this.showSuccessMsg('Episode deleted from your library.');
          this.shows.in_library = false;
          this.eventProvider.triggerEpisodeRemoveEvent(this.shows);
        })
        .catch(() => {
          this.$emit('deleted', 0);
          this.deleting_episode = false;
          this.showErrorMsg('Couldn\'t delete this episode from your library. Please try again.');
        });
    },
    onVisibleInViewport() {
      const ele = document.querySelector(`.show-card-list[data-segment-uuid="${this.shows.uuid}"]`);
      if (ele) {
        ele.classList.add('is-visible');
      }
    },
    triggerContentSelectEvent() {
      const bucketItemData = { ...this.shows };
      bucketItemData.item_position = this.$vnode.key;
      delete bucketItemData.podcast;
      this.eventProvider.triggerContentSelectEvent(this.bucket, bucketItemData);
    },
    goToEDP() {
      this.$router.push(`/listen/${this.podcast.publisher.slug}/${this.podcast.slug}/${this.shows.slug}/${this.shows.uuid}`);
    },
  },
};
</script>
<style scoped lang="scss">
// THE CSS BELOW IS VERY SENSITIVE. DON'T ALTER IT UNLESS IT'S ABSOLUTEY NECESSARY !!!
  @import "../assets/scss/variables.scss";
  @import "../assets/scss/mixins.scss";
  ::selection {
    opacity: 0 !important;
  }
  .show-card-list {
    background-color: $episode-card-background;
    border-radius: 0px;
    &:hover {
      cursor: pointer;
    }
    .draggable-element {
      display: flex;
      visibility: hidden;
      width: 360px;
      height: 0;
      align-items: center;
      z-index: 3;
      padding: .5rem;
      border-radius:10px;
      background-color: #fff !important;
      box-shadow: 0px 0px 10px 6px rgba(200,200,200,.3);
      opacity: 1;
      .picture-component {
        width:80px;
        height: 80px;
      }
      p {
        margin:0 15px;
        width: auto;
        display: inline-block;
      }
    }
    .main-content {
      border-bottom: 1px solid $dark-background;
      padding-bottom: 18px;
      position: relative;
      &.without-border {
        border-bottom: none;
      }

      .tags {
        position: relative;
        left: 117px;
        margin-bottom: 8px;

        @media (max-width: 1200px) {
          left: 106px;
        }

        @media (max-width: 1024px) {
          left: 76px;
        }

        @media (max-width: 768px) {
          left: 81px;
        }

        @media (max-width: 576px) {
          display: none;
        }
      }

      .show-play-button {
        display: flex;
        align-items: center;
        margin-left: 30px;
        min-width: 46px;
        visibility: visible !important;
        > div {
          cursor: pointer;
        }
        img, svg {
          cursor: pointer;
          visibility: visible !important;
          &.play-button {
            position: absolute;
            left: 43px;
            width: 20px;
            height: 20px;
          }
          &.pause-button {
            position: absolute;
            left: 43px;
            width: 16px;
            height: 16px;
          }
          &.replay-button {
            width: 46px;
            height: 46px;
          }
        }
        i {
          position: absolute;
          left: 41px;
          font-size: 20px;
        }
      }
      .show-content {
        flex: 1;
        max-width: 964px;
        margin: 0 15px 0 40px;
        .tags {
          display: none;
        }
        a {
          color: #fff ;
          display: block;
          margin-bottom: 8px;
          @include multilinetruncate(20px,24px,1);
          &:hover {
            text-decoration: underline;
            color: $blue;
          }
        }
        .description {
          color: #fff;
          margin-bottom: 0 !important;
          @include multilinetruncate(14px, 18px, 2);
          margin-top: 8px;
          word-break: break-word;
        }
        .responsive-details,
        .meta-and-action {
          display: flex;
          align-items: center;
          color: $light-gray3;
          margin-top: 10px;
          font-size: 14px;
          .add-remove-btn {
            display: flex;
            align-items: center;
            font-family: $clear-sans;
            img, span {
              cursor: pointer;
            }
            span:hover {
              text-decoration: underline;
            }
            .processing {
              width: 150px;
              display: flex;
              align-items: center;
              color: $blue;
              font-size: 16px;
              i {
                font-size: 24px;
                margin-right: 12px;
                color: $blue;
              }
            }
            span:not(.processing) {
              margin-left: 12px;
              color: $blue;
            }
            div, svg {
              width: 24px;
              height: 24px;
            }
          }
          .meta {
            display: flex;
            align-items: center;
            color: $light-gray3;
            min-width: 246px;
            margin-right: 21px;
            .show-season, .show-date, .show-duration {
              padding: 8px;
              max-width: 80px;
              p {
                margin: 0 0 !important;
                color: $light-gray3;
                font-size: 14px;
                text-align: right;
              }
              &:first-child {
                padding-left: 0;
              }
            }
            .show-date {
              max-width: 90px !important;
            }
            .show-duration {
              max-width: 85px;
            }
          }
        }
        .show-image-responsive {
          display: none; // should be flex on required screen
        }
      }
      .responsive-meta-and-actions {
        display: none;
        margin-top: 16px;
        .responsive-buttons {
          display: none;
        }
        .responsive-details {
        }
      }
      .show-image {
        width: 86px;
        height: 86px;
        margin: 0 35px 0 95px;
        position: relative;
        cursor: pointer;
        &:not(.is-draggable) {
          margin-right: 0 !important;
        }
      }
      .drag-button {
        display: flex;
        align-items: center;
        img {
          &:hover {
            cursor: move;
          }
        }
      }
    }
    .border {
      background: $xlight-gray;
      height: 1px;
    }

    .picture-component {
      object-fit: contain;
    }
  }
  @media (max-width: $lg) {
    .show-card-list {
      .main-content {
        .show-content {
          margin: 0 10px 0 30px;
          .show-image-responsive {
            display: none;
          }
        }
        .show-season {
          margin-left: 0 !important;
        }
        .show-season, .show-date, .show-duration {
          // margin: 0 15px;
        }
        .show-image {
          margin: 0 15px 0 15px !important;
        }
      }
    }
  }
  @media (max-width: $md) {
    .show-card-list {
      padding: 12px 0px 0 0px;
      .main-content {
        .show-play-button {
          margin-left: 10px;
          img,svg {
            left: 23px !important;
          }
          i {
            left: 21px !important;
          }
        }
        .show-content {
          flex:1;
          margin: 0 5px 0 20px;
          .meta-and-action {
            .meta {
              min-width: 265px;
            }
          }
        }
       .show-season, .show-date,.show-duration {
         margin: 0 5px;
       }
       .show-image {
         margin: 0 0 0 30px !important;
         &.is-draggable {
           margin-right: 15px !important;
         }
       }
      }
    }
  }
  @media (max-width: $sm) {
    .show-card-list {
      padding: 12px 0px 0 0px;
      .main-content {
        .show-play-button {
          margin-left: 5px;
          img , svg {
            left: 18px !important;
          }
          i {
            left: 16px !important;
          }
        }
        .show-content {
          max-width: unset;
          margin: 0 20px 0 30px;
          a {
            font-size: 18px;
            line-height: 22px;
            font-family: $clear-sans;
            font-weight: 500;
          }
          .responsive-details {
            display: none;
            margin: 5px 0;
            span {
              line-height: 10px;
              color: $light-gray3;
              font-size: 14px;
              padding-right: 8px;
              margin-right: 3px;
              border-right:1px solid $light-gray3;
              &:last-of-type {
                margin-right: 0;
                padding-right: 0;
                border: none;
              }
            }
          }
          .description {
            height: 36px;
          }
          .meta-and-action {
            .meta {
              min-width: 265px;
            }
          }
        }
        .show-season, .show-date, .show-duration {
          display: block;
        }
        .show-image {
          margin: 0 37px 0 27px !important;
        }
      }
    }
  }
  @media (max-width: $xs) {
    .show-card-list {
      padding: 12px 0px 0 0px;

      .main-content {
        .tags {
          display: none;
          left: 0;
        }

        .show-play-button {
          margin-left: 0 !important;
        }

        .show-play-button {
          display: none;
        }

        .show-content {
         margin: 0 0;

         .tags {
           display: inline-block;
           left: 0;
         }

         .meta-and-action, .add-remove-btn {
           display: none;
           margin-top: 0 !important;
         }

         > div {
           display: flex;
           justify-content: space-between;

           > div {
            a {
              font-size: 16px;
              line-height: 22px;
              height: 42px;
              word-break: break-word;
            }

            &:nth-child(1) {
                margin-right: 15px;
            }
           }

          .show-image-responsive {
            display: none;
            position: relative;

            .picture-component {
              width: 76px;
              height: 76px;
            }
          }
         }

          .responsive-details {
            display: block;
            span {
              font-size: 11px;
            }
          }

          .description {
            font-size: 12px;
            line-height: 18px;
            margin-top: 0px !important;
            height: 54px;
          }
        }
        .responsive-meta-and-actions {
          display: flex !important;
          justify-content: space-between;
          align-items: center;
          .responsive-buttons {
            display: flex !important;
            justify-content: space-between;
            align-items: center;

            .show-play-button {
              display: block;
              position: relative;

              .play-button {
                bottom: 17px;
                left: 12px !important;
              }

              .pause-button {
                bottom: 18px;
                width: 16px;
                height: 16px;
                left: 13px !important;
              }

              i {
                bottom: 16px;
                left: 11px !important;
              }
            }

            .btn-left {
              display: flex !important;
              justify-content: space-between;
              align-items: center;

              .add-remove-btn {
                display: flex;

                span {
                  display: none;
                  margin-left: 10px;
                  font-family: $clear-sans;
                }
              }

              .border-vertical {
                width: 1px;
                height:24px;
                margin:0 15px;
                background-color: $xlight-gray;
              }

              .drag-button {
                display: block !important;

                img {
                  margin-top:5px;
                }
              }
            }
          }
          .responsive-details {
            display: flex;
            align-items: center;
            color: $light-gray3;
            margin-top: 10px;
            font-size: 12px;
            .add-remove-btn {
              display: flex;
              align-items: center;
              font-family: $clear-sans;
              img, span {
                cursor: pointer;
              }
              .processing {
                width: 150px;
                display: flex;
                align-items: center;
                color: $blue;
                font-size: 16px;
                i {
                  font-size: 24px;
                  margin-right: 12px;
                  color: $blue;
                }
              }
              span:not(.processing) {
                margin-left: 12px;
                color: $blue;
              }
              div, svg {
                width: 24px;
                height: 24px;
              }
            }
            .meta {
              display: flex;
              align-items: center;
              color: $light-gray3;
              min-width: 246px;
              margin-right: 21px;
              .show-season, .show-date, .show-duration {
                padding: 8px;
                max-width: 80px;
                p {
                  margin: 0 0 !important;
                  color: $light-gray3;
                  font-size: 14px;
                  text-align: right;
                }
                &:first-child {
                  padding-left: 0;
                }
              }
              .show-date {
                max-width: 90px !important;
              }
              .show-duration {
                max-width: 85px;
              }
            }
            > span {
              margin-right: 4px;
              margin-left: 4px;
            }
          }
        }
        .show-image {
          margin: 0 0 0 8px !important;
          &.is-draggable {
            margin-right: 0px !important;
          }
        }
      }
      .drag-button {
        display: none !important;
      }
    }
  }
</style>
